module.exports = __webpack_public_path__ + "media/images/team/david_gould-74f6cdb86d4c0477c086104d9452d242.png";